import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives, createBlock as _createBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "as-incident as-incident__tennis"
}
const _hoisted_2 = {
  key: 0,
  class: "as-incident__head"
}
const _hoisted_3 = { class: "as-player" }
const _hoisted_4 = { class: "as-player as-player__away" }
const _hoisted_5 = { class: "as-incident__list" }
const _hoisted_6 = ["onClick"]
const _hoisted_7 = { class: "as-incident_row" }
const _hoisted_8 = { class: "as__left" }
const _hoisted_9 = { class: "as-item-left as-item-left__top" }
const _hoisted_10 = { class: "as__live" }
const _hoisted_11 = { class: "as-item-left as-item-left__bottom" }
const _hoisted_12 = { class: "as__live" }

import { ref, computed } from "vue";
  import { mapPlayer } from "~src/helpers/basketball";
  import ArrowDown from "~src/components/icons/ArrowDown.vue";
  import IncidentPlayer from "~src/components/incidents/tennis/IncidentPlayer.vue";
  import NoData from "~src/components/NoData.vue";
import TennisLive from "~src/components/icons/TennisLive.vue";
import PlayerTennis from "~src/components/player/PlayerTennis.vue";
  
const __default__ = {};

interface IProps {
    isPopup: boolean;
    detailShooting: any;
  }

  
export default /*@__PURE__*/_defineComponent({
  ...__default__,
  __name: 'IncidentsList',
  props: {
    isPopup: { type: Boolean, default: true },
    detailShooting: {}
  },
  setup(__props: any) {

  const props = __props;

  const findMaxPointPlayer = (listPlayer: Array<any>, teamId: number) => {
    let maxPoint = 0;
    let maxPointPlayer = null;
    if (!listPlayer) return null;
    listPlayer.forEach((player: any) => {
      if (player.teamId === teamId && player.totalPoint > maxPoint) {
        maxPoint = player.point;
        maxPointPlayer = player;
      }
    });
    return maxPointPlayer;
  };

  const playerHomeTeamMaxPoint: any = computed(() =>
    findMaxPointPlayer(props?.detailShooting?.groupByPlayerData, 1)
  );
  const playerAwayTeamMaxPoint: any = computed(() =>
    findMaxPointPlayer(props?.detailShooting?.groupByPlayerData, 2)
  );
  const rows = computed(() => {
    return props?.detailShooting?.shootingPointsConverted;
  });

  const collapses = computed(() => {
    if (!props?.detailShooting?.shootingPointsConverted) return [];
    const data = []
    for (const [key, value] of Object.entries(props?.detailShooting?.shootingPointsConverted) as any) {
      const homePoints = value[value.length - 1][9];
      const awayPoint = value[value.length - 1][10];
      const res: { title: string; value: string } = {
        title:
          key === "4"
            ? `FT ${homePoints} - ${awayPoint}`
            : `H${key} ${homePoints} - ${awayPoint}`,
        value: key as string,
      };
      data.push(res);
    }
    return data.reverse();
  });

  const activeCollapse = ref(collapses?.value[0]?.value) || 0;

  const changeActiveCollapse = (index: any) => {
    if(activeCollapse.value === index) {
      activeCollapse.value = '';
    } else {
      activeCollapse.value = index;
    }
  }
  
return (_ctx: any,_cache: any) => {
  return (rows.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (rows.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _createVNode(PlayerTennis, {
                  _class: "away",
                  scores: playerHomeTeamMaxPoint.value.totalPoint,
                  name: _unref(mapPlayer)(
                  playerHomeTeamMaxPoint.value.id,
                  props?.detailShooting?.listPlayer
                )?.name,
                  img: _ctx.getImgUrlBySport('player', playerHomeTeamMaxPoint.value?.id as string)
                }, null, 8, ["scores", "name", "img"])
              ]),
              _createElementVNode("div", _hoisted_4, [
                _createVNode(PlayerTennis, {
                  scores: playerHomeTeamMaxPoint.value.totalPoint,
                  name: _unref(mapPlayer)(
                  playerAwayTeamMaxPoint.value.id,
                  props?.detailShooting?.listPlayer
                )?.name,
                  img: _ctx.getImgUrlBySport('player', playerAwayTeamMaxPoint.value?.id as string)
                }, null, 8, ["scores", "name", "img"])
              ])
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_5, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(rows.value, (row, index) => {
            return (_openBlock(), _createElementBlock("div", {
              key: index,
              class: "as-incident__item"
            }, [
              _createElementVNode("h3", {
                onClick: ($event: any) => (changeActiveCollapse(index.toString())),
                class: _normalizeClass({
              'as-active': _unref(activeCollapse) === index.toString(),
            })
              }, [
                _createElementVNode("span", null, _toDisplayString(collapses.value.find((collapse) => collapse.value === index.toString())
                ?.title), 1),
                _createVNode(ArrowDown, { fill: "#4CF446" })
              ], 10, _hoisted_6),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(row, (data) => {
                return _withDirectives((_openBlock(), _createElementBlock("div", null, [
                  _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("div", _hoisted_8, [
                      _createElementVNode("div", _hoisted_9, [
                        _cache[0] || (_cache[0] = _createTextVNode(" 1 ")),
                        _createElementVNode("div", _hoisted_10, [
                          _createVNode(TennisLive)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_11, [
                        _cache[1] || (_cache[1] = _createTextVNode(" 2 ")),
                        _createElementVNode("div", _hoisted_12, [
                          _createVNode(TennisLive)
                        ])
                      ])
                    ]),
                    _cache[2] || (_cache[2] = _createStaticVNode("<div class=\"as__right\"><div class=\"as-item-right as-item-right__top\"><span class=\"as__white\">0</span><span>0</span><span>0</span><span>0</span><span class=\"as__white\">0</span><span>0</span><span>0</span><span>0</span><span class=\"as__white\">0</span><span>0</span><span>0</span><span>0</span><span class=\"as__white\">0</span><span>0</span><span>0</span><span>0</span></div><div class=\"as-item-right as-item-right__bottom\"><span>0</span><span>0</span><span class=\"as__white\">0</span><span>0</span></div></div>", 1))
                  ])
                ], 512)), [
                  [_vShow, _unref(activeCollapse) == index.toString()]
                ])
              }), 256))
            ]))
          }), 128))
        ])
      ]))
    : (_openBlock(), _createBlock(NoData, { key: 1 }))
}
}

})